<template>
  <McGrapqlTable
    :apiClient="query"
    :fields="fields"
    :customHandlers="customHandlers"
    :hasCheckbox="false"
    :searchable="true"
    :isSelectableField="false"
    :withCard="false"
    :stickyHeader="true"
  >
    <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
      <TableViewManager
        :defaultColumnOrder="initialFields"
        :currentColumnOrder="dataFields"
        @setColumn="handleSetDataFields"
      />
    </template>
  </McGrapqlTable>
</template>
<script>
import McGrapqlTable from '@/components/McGrapqlTable'
import TableViewManager from '../../components/TableViewManager.vue'

export default {
  components: {
    McGrapqlTable,
    TableViewManager,
  },
  data() {
    return {
      data: {},
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'notifCheck',
          label: '',
          isSortable: false,
          tdAttr: {
            style:
              'position: -webkit-sticky;position: sticky;background-color: white;width: 50px;min-width: 50px;max-width: 50px;left: 0px;z-index:1',
          },
          thAttr: {
            style:
              'position: -webkit-sticky;position: sticky;background-color: white;width: 50px;min-width: 50px;max-width: 50px;left: 0px;z-index:1',
          },
          order: 1
        },
        {
          key: 'start',
          label: this.$t('global.object.startTime'),
          isSortable: true,
          order: 2
        },
        {
          key: 'stop',
          label: this.$t('global.object.stopTime'),
          order: 3
        },
        {
          key: 'driver',
          label: this.$t('global.object.driver'),
          isSortable: true,
          order: 4
        },
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          isSortable: true,
          order: 5
        },
        {
          key: 'mileage',
          label: this.$t('global.object.mileage'),
          isSortable: true,
          order: 6
        },
        {
          key: 'fullUsage',
          label: this.$t('dashboard.chart.fuelUse') + ' (L)',
          order: 7
        },
        {
          key: 'fullEfisien',
          label: this.$t('master.form.fleet.fuelEfficiency'),
          isSortable: true,
          order: 8
        },
        {
          key: 'timeStart',
          label: 'Waktu Berjalan (Jam)',
          isSortable: true,
          order: 9
        },
        {
          key: 'timeIdle',
          label: 'Waktu Diam (Jam)',
          isSortable: true,
          order: 10
        },
        {
          key: 'timeStop',
          label: 'Waktu Berhenti (Jam)',
          isSortable: true,
          order: 11
        },
        {
          key: 'totalMileage',
          label: this.$t('liveView.modal.totalTripTime') + '(Jam)',
          isSortable: true,
          order: 12
        },
        {
          key: 'speedAverage',
          label: this.$t('report.fields.averageSpeed'),
          isSortable: true,
          order: 13
        },
      ]
    },
  },
}
</script>
